import type {JobNodes} from "#job-nodes/job-nodes"
import {makeJobTaskDescriptor} from "#job-nodes/job-nodes"

export type DisplacementGenerationInput = {
    organizationLegacyId: number
    pxPerCm: number
    normalMapDataObject: JobNodes.DataObjectReference
}

export type DisplacementGenerationOutput = {
    log: JobNodes.DataObjectReference
    displacementMapDataObjectReference: JobNodes.DataObjectReference
    displacementCm: number
}

export const displacementGenerationTask = makeJobTaskDescriptor<DisplacementGenerationInput, DisplacementGenerationOutput>("Tiling.displacementGeneration", 1)
